import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getRolesQueryKey = (includeAssignmentCounts = true) => {
    const baseKey = QueryClientHelper.makeQueryKey('rbac', 'roles');
    return includeAssignmentCounts ? baseKey : [...baseKey, 'without-assignment-counts'];
};
export const getRoleQueryKey = (roleId) => QueryClientHelper.makeQueryKey('rbac', 'roles', roleId);
export const getRoleComputerEffortPolicyQueryKey = (roleId) => QueryClientHelper.makeQueryKey('rbac', 'role-computer-effort-policy', roleId);
export const getRoleMembersQueryKeyPrefix = (roleId) => QueryClientHelper.makeQueryKey('rbac', 'roles', roleId, 'members');
export const getRoleMembersQueryKey = (roleId, search) => [
    ...getRoleMembersQueryKeyPrefix(roleId),
    search,
];
export const getRoleGroupsQueryKeyPrefix = (roleId) => QueryClientHelper.makeQueryKey('rbac', 'roles', roleId, 'groups');
export const getRoleGroupsQueryKey = (roleId, search) => [
    ...getRoleGroupsQueryKeyPrefix(roleId),
    search,
];
export const getGroupsQueryKey = () => QueryClientHelper.makeQueryKey('rbac', 'groups');
export const getGroupQueryKey = (groupId) => QueryClientHelper.makeQueryKey('rbac', 'groups', groupId);
export const getGroupMembersQueryKeyPrefix = (groupId) => QueryClientHelper.makeQueryKey('rbac', 'groups', groupId, 'members');
export const getGroupMembersQueryKey = (groupId, search) => [...getGroupMembersQueryKeyPrefix(groupId), search];
export const getGroupRolesQueryKeyPrefix = (groupId) => QueryClientHelper.makeQueryKey('rbac', 'groups', groupId, 'roles');
export const getUserGroupsQueryKey = (userId) => QueryClientHelper.makeQueryKey('rbac', 'users', userId, 'groups');
export const getPluginMemberCapabilitiesQueryKey = (orgUuid) => QueryClientHelper.makeQueryKey('rbac', 'plugin-member-capabilities', orgUuid);
export const getPermissionsQueryKey = () => QueryClientHelper.makeQueryKey('rbac', 'permissions');
export const getEffectivePermissionsQueryKeyPrefix = (orgUuid) => QueryClientHelper.makeQueryKey('rbac', 'permissions', 'effective', orgUuid);
// Deliberately excludes the RBAC revision token: rotating the key on every
// role mutation would discard the cached set and flap every loading-aware
// permission gate (sidebar tabs, page gates) through a loading state. The
// fetch reads the latest stored token at request time instead, so
// read-after-write consistency holds while invalidation stays a seamless
// background refetch.
export const getEffectivePermissionsQueryKey = (orgUuid, userId) => [...getEffectivePermissionsQueryKeyPrefix(orgUuid), userId];
//# sourceMappingURL=rbacKeys.js.map